import { useEffect, useState } from 'react';

/**
 * Seconds left before a code can be asked for again.
 *
 * Driven by an absolute instant supplied by the server rather than a count the
 * client starts, so reloading the page mid-cooldown resumes where it was
 * instead of handing out a fresh allowance. This is display only — the real
 * limit is enforced server-side; a countdown in a browser is a courtesy, not a
 * control.
 */
function useResendCooldown(resendAt) {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    setSecondsLeft(resendAt ? Math.max(0, Math.ceil((resendAt - Date.now()) / 1000)) : 0);
    if (!resendAt) return undefined;

    const id = setInterval(() => {
      const left = Math.max(0, Math.ceil((resendAt - Date.now()) / 1000));
      setSecondsLeft(left);
      if (left === 0) clearInterval(id);
    }, 1000);

    return () => clearInterval(id);
  }, [resendAt]);

  return secondsLeft;
}

export default useResendCooldown;
